import { loginInput, type LoginInput } from '@mg/shared';
import { AyudaVentana } from '@/ayuda/BotonAyuda.tsx';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { Button } from '@/componentes/ui/button.tsx';
import { Input } from '@/componentes/ui/input.tsx';
import { Campo } from '@/componentes/ui/label.tsx';
import { mensajeDeError } from '@/lib/api.ts';
import { useAuth } from '@/lib/auth.tsx';

export function Login() {
  const { usuario, iniciarSesion, cargando } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [errorGeneral, setErrorGeneral] = useState<string | null>(null);
  const form = useForm<LoginInput>({ resolver: zodResolver(loginInput), defaultValues: { email: '', password: '' } });

  if (!cargando && usuario) return <Navigate to={usuario.rol === 'superadmin' && !usuario.sucursal_id ? '/consolidado' : '/'} replace />;

  const enviar = form.handleSubmit(async (datos) => {
    setErrorGeneral(null);
    try {
      const u = await iniciarSesion(datos.email, datos.password);
      const destino = (location.state as { desde?: string } | null)?.desde;
      if (u.rol === 'superadmin' && !u.sucursal_id) navigate('/consolidado', { replace: true });
      else if (u.rol === 'cajero' && !u.sesion_caja) navigate('/caja', { replace: true });
      else navigate(destino && destino !== '/login' ? destino : '/', { replace: true });
    } catch (e) {
      setErrorGeneral(mensajeDeError(e));
    }
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-mg-verde-oscuro p-4">
      <div className="w-full max-w-sm rounded-2xl bg-card p-8 shadow-xl">
        <div className="mb-6 flex flex-col items-center gap-3 text-center">
          <img src="/logo-mg.png" alt="Materiales y Decoraciones MG" className="h-16 w-16 object-contain" />
          <div>
            <h1 className="text-lg font-bold">MG ERP</h1>
            <p className="text-sm text-muted-foreground">Materiales y Decoraciones MG</p>
          </div>
        </div>
        <form onSubmit={enviar} className="space-y-4" noValidate>
          <Campo etiqueta="Correo" htmlFor="email" error={form.formState.errors.email?.message}>
            <Input id="email" type="email" autoComplete="username" autoFocus placeholder="usuario@materialesmg.com" aria-invalid={!!form.formState.errors.email} {...form.register('email')} />
          </Campo>
          <Campo etiqueta="Contraseña" htmlFor="password" error={form.formState.errors.password?.message}>
            <Input id="password" type="password" autoComplete="current-password" aria-invalid={!!form.formState.errors.password} {...form.register('password')} />
          </Campo>
          {errorGeneral ? (
            <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-800" data-testid="login-error">
              {errorGeneral}
            </p>
          ) : null}
          <Button type="submit" className="w-full" cargando={form.formState.isSubmitting} data-testid="btn-entrar">
            Entrar
          </Button>
        </form>
        <p className="mt-6 text-center text-[11px] text-muted-foreground">Tu sucursal y tu rol los define el administrador. No hay selector de sucursal.</p>
        <p className="mt-2 flex items-center justify-center gap-1 text-[11px] text-muted-foreground">¿Problemas para entrar? <AyudaVentana tema="login" /></p>
      </div>
    </div>
  );
}
